(() => {
  const videos=[...document.querySelectorAll('[data-campaign-video]')];
  if(!videos.length)return;
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  const visible=new WeakSet();
  function update(video){
    if(reduce.matches||document.hidden||!visible.has(video)){video.pause();return;}
    const source=video.querySelector('source[data-src]');
    if(source){source.src=source.dataset.src;source.removeAttribute('data-src');video.load();}
    video.muted=true;
    const playback=video.play();
    if(playback)playback.catch(()=>{});
  }
  videos.forEach(video=>{video.muted=true;video.pause();});
  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      entry.isIntersecting?visible.add(entry.target):visible.delete(entry.target);
      update(entry.target);
    }),{threshold:.1});
    videos.forEach(video=>observer.observe(video));
  }else{videos.forEach(video=>{visible.add(video);update(video);});}
  const refresh=()=>videos.forEach(update);
  reduce.addEventListener('change',refresh);
  document.addEventListener('visibilitychange',refresh);
})();
